import styles from '../styles/components/nav.module.css';

import { ReactComponent as ChannelIcon } from "../assets/channel.svg";
import { ReactComponent as MainIcon } from "../assets/components/nav/subList.svg";
import { useNavigate } from 'react-router-dom';


interface ComponentProps {
    activePage: number;
};


export default function AdminNav({activePage}: ComponentProps) {
    const tg = window.Telegram.WebApp;
    const navigate = useNavigate();

    const handleNavigate = (path: string) => {
        tg.HapticFeedback.impactOccurred("heavy");
        navigate(path, { replace: true });
    };

    return <div className={styles.base_pages}>
        <div className={activePage === 1 ? styles.page_button__active : styles.page_button} onClick={() => handleNavigate('/admin/moderation')}><MainIcon/>Модерация</div>
        <div className={activePage === 2 ? styles.page_button__active : styles.page_button} onClick={() => handleNavigate('/admin/chat')}><ChannelIcon/>Каналы</div>
    </div>;
};